
import {serializable, alias, object, list, primitive} from 'serializr';

export class StudentMetricsModel { 

	@serializable(alias('total_students', primitive()))
	totalStudents?: number;

	@serializable(alias('total_active_students', primitive()))
	totalActiveStudents?: number;

	@serializable(alias('total_inactive_students', primitive()))
	totalInactiveStudents?: number;

	@serializable(alias('total_self_onboard_students', primitive()))
	totalSelfOnboardStudents?: number;

	@serializable(alias('total_self_onboard_active_students', primitive()))
	totalSelfOnboardActiveStudents?: number;

	@serializable(alias('total_self_onboard_inactive_students', primitive()))
	totalSelfOnboardInactiveStudents?: number;

	@serializable(alias('total_institute_students', primitive()))
	totalInstituteStudents?: number;

	@serializable(alias('total_institute_active_students', primitive()))
	totalInstituteActiveStudents?: number;

	@serializable(alias('total_institute_inactive_students', primitive()))
	totalInstituteInactiveStudents?: number;

	@serializable(alias('total_videos', primitive()))
	totalVideos?: number;

	@serializable(alias('total_pdfs', primitive()))
	totalPdfs?: number;

	@serializable(alias('total_quick_quiz', primitive()))
	totalQuickQuiz?: number;

	@serializable(alias('total_excercises', primitive()))
	totalExcercises?: number;

}